<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            REGISTRO DE ENTRADAS/SAÍDAS
          </h4>
          <div v-show="tela == 1">
            <div class="row p-1">
              <div class="col-sm-12 text-left mt-1">
                <div class="d-flex">
                  <div class="mr-3 form-group text-left has-label">
                    <label>
                      Tipos de filtro
                    </label>
                    <el-select
                      class="select-success pagination-select"
                      placeholder="Todos os filtros"
                      v-model="filtro"
                    >
                      <el-option
                        v-for="item in filtros"
                        :key="item.id"
                        class="select-success"
                        :label="item.tipo"
                        :value="item.id"
                        >{{ item.tipo }}</el-option
                      >
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <BaseFiltroRelatorio
              tipo="basico"
              @pesquisar="pesquisar"
              :btEnviarEmail="false"
              :isMessage="false"
            />
          </div>
          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>
            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      {{ pegarTitulo() }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à
                          ${moment(payloadPesquisa.data_final).format(
                            "DD/MM/YYYY",
                          )}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `DEPARTAMENTO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `POSTO DE TRABALHO: NENHUM` }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col text-left">
                      {{ `TOTAL DE FUNCIONÁRIOS ATIVOS: ${dados.length}` }}
                    </div>
                  </div> -->

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Tabela de Resultados-->
            <div class="table-responsive p-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Dia</th>
                    <th scope="col">Departamento</th>
                    <th scope="col">Horário permitido para registro</th>
                    <th scope="col">{{ pegarLabel() }}</th>
                    <th scope="col">Diferença</th>
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, index) in dados">
                    <tr :key="`${item.data}-${item.nome}`">
                      <th>
                        <p class="m-0 p-0">{{ item.nome }}</p>
                      </th>
                      <th>
                        <p class="m-0 p-0">{{ item.data }}</p>
                      </th>
                      <th>
                        <p class="m-0 p-0">{{ item.departamento }}</p>
                      </th>
                      <th>
                        <p class="m-0 p-0">
                          {{ pegarHorarioPermitido(item.dadosEscala) }}
                        </p>
                      </th>
                      <th>
                        <p class="m-0 p-0">
                          {{ pegarHorarioBatida(item.batidas) }}
                        </p>
                      </th>
                      <th
                        :class="{
                          'bg-success': isEntradaOuSaidaAntecipada(item),
                          'bg-danger': isEntradaOuSaidaAtrasada(item),
                        }"
                      >
                        <p class="m-0 p-0">{{ pegarDiferenca(item) || "-" }}</p>
                      </th>
                      <th>
                        <p class="m-0 p-0"></p>
                      </th>
                    </tr>
                    <tr
                      v-if="
                        !dados[index + 1] || item.nome !== dados[index + 1].nome
                      "
                      :key="`${item.data}-${item.nome}-total`"
                    >
                      <td colspan="6" class="text-right font-weight-bold">
                        TOTAL:
                      </td>
                      <td>
                        <p class="m-0 p-0">{{ calcularTotal(item.nome) }}</p>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!--Paginação-->
            <Paginacao
              v-show="!printing"
              :currentPage="pagination.currentPage"
              :totalPages="pagination.totalPages"
              @page-changed="listarEntradaSaida"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseFiltroRelatorio, Paginacao } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";
import axios from "axios"; // Certifique-se de importar axios para chamadas HTTP

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseFiltroRelatorio,
    Paginacao,
  },
  data() {
    return {
      isLoading: false,
      filtros: [
        { id: 1, tipo: "Entradas Antecipadas" },
        { id: 2, tipo: "Saídas Atrasadas" },
        { id: 3, tipo: "Entradas Atrasadas" },
        { id: 4, tipo: "Saídas Antecipadas" },
      ],
      filtro: 1,
      dados: [],
      payloadPesquisa: Object,
      tela: 1,
      printing: false,
      pagination: {
        currentPage: 1,
        perPage: 20,
        totalItems: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    pesquisar(event) {
      this.payloadPesquisa = event;
      this.listarEntradaSaida(1);
    },
    async listarEntradaSaida(page = 1) {
      this.isLoading = true;
      const payload = {
        ...this.payloadPesquisa,
        page,
        tipo: this.filtro,
        limit: this.pagination.perPage,
      };
      this.payloadPesquisa = payload;

      try {
        const response = await axios.post(
          "/api/relatorio/listarRelatorioEntradaSaida",
          payload,
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );
        if (response.data.status) {
          this.pagination = response.data.data.pagination;
          this.dados = response.data.data.dados.sort((a, b) => {
            if (a.nome < b.nome) {
              return -1;
            } else if (a.nome > b.nome) {
              return 1;
            } else {
              if (moment(a.data).isBefore(moment(b.data))) {
                return -1;
              } else if (moment(a.data).isAfter(moment(b.data))) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          this.tela = 2;
        } else {
          this.showSwal(
            "error",
            "Erro",
            "Falha ao carregar o relatório.",
            "error",
          );
        }
      } catch (error) {
        console.error("Erro ao listar relatório de entrada e saída:", error);
        this.showSwal(
          "error",
          "Erro",
          "Ocorreu um erro ao buscar os dados.",
          "error",
        );
      } finally {
        this.isLoading = false;
      }
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    moment: function(data) {
      return moment(data);
    },
    pegarTitulo() {
      return this.filtros.find((filtro) => filtro.id === this.filtro).tipo;
    },
    pegarLabel() {
      return this.filtro === 2 || this.filtro === 4 ? "Saída" : "Entrada";
    },
    pegarHorarioPermitido(escala) {
      if (escala) {
        if (this.filtro === 1 || this.filtro === 3) {
          return moment(escala.data.entrada_1).format("HH:mm");
        }
        if (this.filtro === 2 || this.filtro === 4) {
          return escala.data.saida_4
            ? moment(escala.data.saida_4).format("HH:mm")
            : moment(escala.data.saida_1).format("HH:mm");
        }
      }
      return "Sem escala";
    },
    pegarHorarioBatida(batidas) {
      if (batidas.length > 0 && (this.filtro === 1 || this.filtro === 3)) {
        return moment(batidas[0]).format("HH:mm");
      }
      if (batidas.length > 1 && (this.filtro === 2 || this.filtro === 4)) {
        const batida = batidas.length > 3 ? batidas[3] : batidas[1];
        return moment(batida).format("HH:mm");
      }
      return "Sem registro";
    },
    isEntradaOuSaidaAntecipada(item) {
      const diferenca = this.pegarDiferenca(item);
      return (
        diferenca &&
        diferenca !== "00:00" &&
        (this.filtro === 1 || this.filtro === 4)
      );
    },
    isEntradaOuSaidaAtrasada(item) {
      const diferenca = this.pegarDiferenca(item);
      return (
        diferenca &&
        diferenca !== "00:00" &&
        (this.filtro === 2 || this.filtro === 3)
      );
    },
    pegarDiferenca(item) {
      switch (this.filtro) {
        case 1:
          return item.entradaAdiantada;
        case 2:
          return item.saidaAtrasada;
        case 3:
          return item.entradaAtrasada;
        case 4:
          return item.saidaAdiantada;
        default:
          return "-";
      }
    },
    calcularTotal(nome) {
      let total = moment.duration();
      this.dados.forEach((item) => {
        if (item.nome === nome) {
          total.add(moment.duration(this.pegarDiferenca(item)));
        }
      });
      const hours = Math.floor(total.asHours())
        .toString()
        .padStart(2, "0");
      const minutes = total
        .minutes()
        .toString()
        .padStart(2, "0");
      return `${hours}:${minutes}`;
    },
  },
};
</script>

<style>
.bg-success {
  background-color: #00ff7f !important;
}

.bg-danger {
  background-color: #fa8072 !important;
}
</style>
